import { Helmet } from "react-helmet-async";
import { useDispatch, useSelector } from "react-redux";
import PageHeader from "./PageHeader";
import PageTitleWrapper from "src/components/PageTitleWrapper";
import { Grid, Container, Card, CardContent } from "@mui/material";
import Wallets from "./Wallets";
import Footer from "src/components/Footer";
import AccountBalance from "./AccountBalance";

function DashboardWelcome() {
  const { user: currentUser } = useSelector((state) => state.auth);

  return (
    <>
      <Helmet>
        <title>Welcome Dashboard</title>
      </Helmet>
      <PageTitleWrapper>
        <PageHeader />
      </PageTitleWrapper>
      {currentUser.roles.includes("ROLE_ADMIN") ? (
        <>
          <Container maxWidth="lg" sx={{ marginBottom: "20px" }}>
            <Grid
              container
              direction="row"
              justifyContent="center"
              alignItems="stretch"
              spacing={4}
            >
              <Grid item xs={6}>
                <Card>
                  <CardContent>Ngupahan</CardContent>
                </Card>
              </Grid>
              <Grid item xs={6}>
                <Card>
                  <CardContent>
                    Tahun Operasional <br />
                    Periode 2023
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
          </Container>
          <Container maxWidth="lg" sx={{ marginBottom: "20px" }}>
            <Grid
              container
              direction="row"
              justifyContent="center"
              alignItems="stretch"
              spacing={4}
            >
              <Grid item lg={3} xs={12}>
                <Card>
                  <CardContent>Total Anggota</CardContent>
                </Card>
              </Grid>
              <Grid item lg={3} xs={12}>
                <Card>
                  <CardContent>Total Berbagi</CardContent>
                </Card>
              </Grid>
              <Grid item lg={3} xs={12}>
                <Card>
                  <CardContent>Total Simpanan</CardContent>
                </Card>
              </Grid>
              <Grid item lg={3} xs={12}>
                <Card>
                  <CardContent>Total Artikel</CardContent>
                </Card>
              </Grid>
            </Grid>
          </Container>
          <Container maxWidth="lg" sx={{ marginBottom: "20px" }}>
            <Grid
              container
              direction="row"
              justifyContent="center"
              alignItems="stretch"
              spacing={4}
            >
              <Grid item lg={12} xs={12}>
                <Card>
                  <CardContent>Grafik Transaksi</CardContent>
                </Card>
              </Grid>
            </Grid>
          </Container>
          <Container maxWidth="lg" sx={{ marginBottom: "20px" }}>
            <Grid
              container
              direction="row"
              justifyContent="center"
              alignItems="stretch"
              spacing={4}
            >
              <Grid item lg={12} xs={12}>
                <Card>
                  <CardContent>Histori Berbagi</CardContent>
                </Card>
              </Grid>
            </Grid>
          </Container>
          <Container maxWidth="lg" sx={{ marginBottom: "20px" }}>
            <Grid
              container
              direction="row"
              justifyContent="center"
              alignItems="stretch"
              spacing={4}
            >
              <Grid item lg={12} xs={12}>
                <Card>
                  <CardContent>Histori</CardContent>
                </Card>
              </Grid>
            </Grid>
          </Container>
        </>
      ) : (
        ""
      )}
      <Footer />
    </>
  );
}

export default DashboardWelcome;
